"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleWrapper = exports.ErrorNotificationButtonContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.ErrorNotificationButtonContainer = styled_components_1.default.button `
  width: 24px;
  height: 24px;
  border: none;
  background-color: ${colors_1.ORANGE};
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  display: flex;
  cursor: pointer;
  outline: none;
`;
exports.TitleWrapper = styled_components_1.default.span `
  padding-top: 4px;
  color: ${colors_1.WHITE};
  letter-spacing: 0.5px;
  font-family: SwegonBrown;
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 20px;
  display: flex;
  align-items: center;
  text-align: center;
`;
//# sourceMappingURL=ErrorNotificationButton.styles.js.map